const coordinate = (receivedCoord) => (
  receivedCoord.latitude != null
    && receivedCoord.longitude != null
    && typeof receivedCoord.latitude === 'number'
    && typeof receivedCoord.longitude === 'number'
    && receivedCoord.latitude >= -90
    && receivedCoord.latitude <= 90
    && receivedCoord.longitude >= -180
    && receivedCoord.longitude <= 180
);

export default coordinate;
